/**
 * Custom Elements
 * Registers custom elements with browsers that support them.
 */

/// <reference path="./CustomElements.d.ts" />

let canRegister = ("registerElement" in document);

export default class CustomElements {
	static add(name: string|Array<string>): void {
		if (canRegister) {
			if (typeof name === "string") {
				document.registerElement(name);
			} else {
				name.forEach(function(value) {
					document.registerElement(value);
				});
			}
		}
	}
}